export const signup = {
  termsPart1: 'Al entrar aceptas los ',
  termsPart2: 'Términos y condiciones de uso',
  termsPart3: ' y las ',
  termsPart4: 'Políticas de privacidad',
  termsPart5: ' de Space Guru.',
  welcome: '¡Bienvenido a Space Guru!',
  labelName: 'Nombre',
  labelLastName: 'Apellido',
  labelPhone: 'Teléfono',
  labelEmail: 'E-mail',
  labelPassword: 'Contraseña',
  button: 'Registrarme',
  iHaveAnAccount: '¿Ya tienes usuario?',
  thenSignIn: 'Ingresa aquí',
  itsSimple: 'Registrarte no te tomará más de 1 minuto.',
  or: 'O ingresa tus datos',
  loginWithFacebook: 'Continúa con Facebook',
}



// WEBPACK FOOTER //
// ./src/sections/signup/text.js